"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ui = require("@alycecom/ui");

var _material = require("@mui/material");

var TemplatesSearch = function TemplatesSearch(_ref) {
  var onSearch = _ref.onSearch,
      search = _ref.search,
      onClickCreate = _ref.onClickCreate,
      onReset = _ref.onReset,
      disabled = _ref.disabled;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    name: "search",
    variant: "outlined",
    placeholder: "Search your templates",
    onChange: onSearch,
    value: search,
    disabled: disabled,
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
        color: "grey.main",
        icon: "search"
      })),
      endAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "end"
      }, search && /*#__PURE__*/_react.default.createElement(_material.ButtonBase, {
        onClick: onReset
      }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
        color: "grey.main",
        icon: "times"
      })))
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 2,
    flexShrink: 0
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    disabled: disabled,
    variant: "primary",
    width: "auto",
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "plus"
    }),
    onClick: onClickCreate
  }, "Create new template")));
};

TemplatesSearch.propTypes = {
  onSearch: _propTypes.default.func.isRequired,
  search: _propTypes.default.string.isRequired,
  onReset: _propTypes.default.func.isRequired,
  onClickCreate: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool
};
TemplatesSearch.defaultProps = {
  disabled: false
};
var _default = TemplatesSearch;
exports.default = _default;